module.exports = __webpack_public_path__ + "static/media/41-3.ee64a8b2.mp3";